import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './iconfont/iconfont.css';
import App from './App';
import ImgList from './components/ImgList';
import {
  HashRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

const Web = (
  <React.StrictMode>
    <Router>
      <Switch>
        <Route key='App' exact path="/">
          <App />
        </Route>
        <Route key="ImgList" path="/imgList/:id" component={ImgList}>
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>
);

ReactDOM.render(
  Web,
  document.getElementById('root')
);